import ScrolledIntoView from '@carvana/stc-scrolled-into-view';
import { useEffect, useState } from 'react';
import { getUserState } from '@carvana/core-auth';

import recordAnalyticsEventMobile, { MobileAnalyticsEvents } from '../analytics/mobileAnalytics';
import { EventActions } from '../analytics/uiMetrics';
import useAnalyticEvent from '../shared/hooks/useAnalyticEvent';
import AppraisalList from './AppraisalList/AppraisalList';
import CustomerReviews from './CustomerReview';
import FAQSection from './FAQs';
import { Container, Inner } from './Header';
import HeroFold from './HeroFold';
import { Background } from './HeroFold/HeroFold.styles';
import Steps from './Steps';
import TradeIn from './TradeIn';
import Worth from './Worth';

const LandingPage = () => {
  const [isWindowLoaded, setIsWindowLoaded] = useState(false);
  const { recordGenericEvent } = useAnalyticEvent();
  const { isLoggedIn } = getUserState();

  useEffect(() => {
    setIsWindowLoaded(true);
    recordGenericEvent('Landing Page', 'LandingPage', EventActions.Visited);
    recordAnalyticsEventMobile(MobileAnalyticsEvents.PageVisited, { pageName: 'Landing Page' });
  }, []);

  return (
    <Container>
      <Inner className="helios">
        {isWindowLoaded && isLoggedIn && <AppraisalList />}
        <Background>
          <HeroFold />
          <Worth />
        </Background>
        <Steps />
        <ScrolledIntoView
          onFirstEnterView={() =>
            recordGenericEvent('Landing Page', 'Social Proof', EventActions.Scrolled)
          }
        >
          <CustomerReviews />
        </ScrolledIntoView>
        <FAQSection />
        <TradeIn />
      </Inner>
    </Container>
  );
};

export default LandingPage;
